var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-list", [_c("a-list-item")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }